module.exports = __webpack_public_path__ + "img/signal_wifi_off.6ef60a28.svg";